export default __webpack_public_path__ + "static/media/hero.42719883.svg";